// =============================================================================
// Licencia del dispositivo (solo app nativa). Al arrancar, la caja valida su
// machine_id contra el tenant; si no está activado, ofrece activarlo (consume
// cupo de cajas del plan). En web no aplica (la web no requiere licencia).
// =============================================================================
import { license as licenseApi } from "../api";
import { isNative } from "./printer";

/** machine_id del equipo (solo nativo). En web devuelve null. */
export async function getMachineId(): Promise<string | null> {
  if (!isNative()) return null;
  const { invoke } = await import("@tauri-apps/api/core");
  return await invoke<string>("machine_id");
}

export interface LicenseState { valid: boolean; reason?: string; status?: string }

/** Valida la licencia del dispositivo. En web siempre válida (no aplica). */
export async function validateLicense(): Promise<LicenseState> {
  const mid = await getMachineId();
  if (!mid) return { valid: true }; // web
  try {
    return await licenseApi.validate(mid);
  } catch (e) {
    return { valid: false, reason: e instanceof Error ? e.message : String(e) };
  }
}

/** Activa este dispositivo (consume cupo de cajas del plan). */
export async function activateLicense(branchId?: string, label?: string): Promise<void> {
  const mid = await getMachineId();
  if (!mid) throw new Error("La activación de licencia solo aplica en la app de caja.");
  await licenseApi.activate(mid, branchId, label);
}
